const pagesIndividualSideNavEn = {
  accountsLedger: 'Accounts',
  approvalTasks: 'Approval Tasks',
  certificationsLedger: 'Certifications',
  devicesLedger: 'Devices',
  equipmentsLedger: 'Equipment',
  lookup: 'Inquiry & Reference',
  operationTasks: 'My Tasks',
  placesLedger: 'Places',
  portal: 'Portal',
  request: 'Request',
  requestTasks: 'Request Tasks'
};
export default pagesIndividualSideNavEn;